import React from 'react';
import { compose } from 'redux';
import G90HomePageTemplate from 'components/templates/G90HomePage';
import HeaderContainer from 'containers/HeaderContainer';
import G90HomeContentContainer from 'containers/home/G90HomeContentContainer';
import moment from 'moment';
import { Footer } from '@goodwaygroup/ui-ux';
import PageTitle from 'hoc/PageTitle';
import PageTheme from 'hoc/PageTheme';
import PageView from 'hoc/PageView';
import ProtectedRoute from 'hoc/ProtectedRoute';
import { G90_HOME_VIEW } from 'constants/capabilities';
import styled from 'styled-components';

const FooterWrapper = styled.div`
    width: 100vw;
    position: absolute;
    bottom: 0;
`;

const G90IndexPage = () => (
    <G90HomePageTemplate>
        <HeaderContainer
            hideLinks
            borderColor="transparent"
        />

        <G90HomeContentContainer />

        <FooterWrapper>
            <Footer year={moment().year()} />
        </FooterWrapper>
    </G90HomePageTemplate>

);

// Prevent auth redirect in development as G90_HOME_VIEW is not defaulted on
// initial site creation and you will get into an infinite redirect loop
const isDevelopment = process.env.NODE_ENV === 'development';

export default compose(
    PageTitle({ pageTitle: 'G90 Home' }),
    PageView({ page: 'Viewed G90 Home Page' }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': true } }),
    ProtectedRoute({ requiredCapabilities: isDevelopment ? [] : [G90_HOME_VIEW] }),
)(G90IndexPage);



// WEBPACK FOOTER //
// ./src/components/pages/home/G90Index.js